import { render } from "./ActiveLightStyle.vue?vue&type=template&id=25e953a4"
import script from "./ActiveLightStyle.vue?vue&type=script&lang=ts"
export * from "./ActiveLightStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script